interface ComingSoonProps {
	title?: string;
	message?: string;
	className?: string;
	isShort?: boolean;
}

export function ComingSoon({
	title = "Feature Coming Soon",
	message = "This feature will be available next week.",
	className = "bg-blue-50 rounded-lg",
	isShort = false,
}: ComingSoonProps) {
	if (isShort) {
		return (
			<div className={`inline-flex items-center gap-2 px-2 py-1 text-sm text-neutral-600 ${className}`}>
				<span>
					{title}: {message}
				</span>
			</div>
		);
	}

	return (
		<div className={`text-center py-8 ${className}`}>
			<h3 className="text-xl font-bold mb-4">{title}</h3>
			<p className="text-neutral-600">{message}</p>
		</div>
	);
}
